var map = {
	"./ser1.png": 5000,
	"./ser2.png": 1859,
	"./ser3.png": 282,
	"./ser4.png": 4581,
	"./ser5.png": 1692,
	"./ser6.png": 167,
	"./ser7.png": 8830,
	"./ser8.png": 7721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7266;